import React from "react";

const ModalLoading = () => {
  return (
    <div className="outer-loader text-center">
      <div className="col-12">
        <div className="sp sp-3balls" />
      </div>
    </div>
  );
};

export default ModalLoading;
